export const firebaseConfig = {
  apiKey: "AIzaSyDglCLUK1n2sHYhKBfhDIELxddDqyZ-_v4",
  authDomain: "er-production-92356.firebaseapp.com",
  databaseURL:
    "https://er-production-92356-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "er-production-92356",
  storageBucket: "er-production-92356.appspot.com",
  messagingSenderId: "289566599766",
  appId: "1:289566599766:web:ff4631bbfbe7620a0c69f7",
  measurementId: "G-5RFVPXCKL2",
};
